export default class MinHeap<T> {
  tree: T[];
  comparator: (value: T) => T | number;

  constructor(comparator: (a: T) => T | number) {
    this.tree = [];
    this.comparator = comparator;
  }

  push(element: T) {
    this.tree.push(element);
    this.bubbleUp(this.tree.length - 1);
  }

  pushAll(elements: T[]) {
    elements.forEach((e) => this.push(e));
  }

  pop() {
    const result = this.tree[0];
    const end = this.tree.pop();
    if (end !== undefined && this.tree.length > 0) {
      this.tree[0] = end;
      this.sinkDown(0);
    }
    return result;
  }

  size() {
    return this.tree.length;
  }

  bubbleUp(current: number) {
    const element = this.tree[current];
    const weight = this.comparator(element);

    let parent, parentIndex;
    while (current > 0) {
      parentIndex = Math.floor((current + 1) / 2) - 1;
      parent = this.tree[parentIndex];

      if (weight >= this.comparator(parent)) {
        break;
      }

      this.tree[current] = parent;
      this.tree[parentIndex] = element;
      current = parentIndex;
    }
  }

  sinkDown(current: number) {
    const length = this.tree.length;
    const element = this.tree[current];
    const weight = this.comparator(element);

    let child, childIndex, childWeight, b, bIndex, bWeight;
    // eslint-disable-next-line no-constant-condition
    while (true) {
      bIndex = (current + 1) * 2;
      childIndex = bIndex - 1;

      if (length > childIndex) {
        child = this.tree[childIndex];
        childWeight = this.comparator(child);
        if (length > bIndex) {
          b = this.tree[bIndex];
          bWeight = this.comparator(b);
          if (bWeight < childWeight) {
            child = b;
            childWeight = bWeight;
            childIndex = bIndex;
          }
        }
      } else {
        break;
      }

      if (childWeight < weight) {
        this.tree[current] = child;
        this.tree[childIndex] = element;
        current = childIndex;
      } else {
        break;
      }
    }
  }
}
